/**
 * 获取随机数
 */
export function getRandomValue() {
  const num = Math.random().toString(36).slice(-6);
  // 当前时间与performance.timing.navigationStart的时间差
  const date = Math.round(performance.now());
  return `${date}_${num}`;
}
